// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4792":"39181c648af8f3c2","7479":"fb1ab718056a3ad0"}[chunkId] + ".js";
};